<div class="container">
  <mat-card>
    <mat-card-header>
      <mat-card-title><h2 class="primaryColor">403 Forbidden</h2></mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <p>You do not have permission to access this page.</p>
    </mat-card-content>
  </mat-card>
</div>

